import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const reasons = ['Intentaste usar solo "fuerza de voluntad", pero la voluntad es un recurso limitado que se agota bajo estrés.', 'Viste videos de "motivación" que te dieron un subidón de 10 minutos pero no cambiaron tu química cerebral.', 'Intentaste dejar tus malos hábitos sin entender cómo transmutar esa energía acumulada en poder real.', 'No tenías una identidad de guerrero; seguías viéndote como una víctima de tus tentaciones.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhyFailed() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-surface border-y border-dark-border" data-id="element-177">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} className="text-center mb-10 sm:mb-16" data-id="element-179">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-180">
            POR QUÉ LO QUE INTENTASTE{' '}
            <span className="text-red-urgent" data-id="element-181">NO FUNCIONÓ</span>
          </h2>
          <div className="w-24 h-[2px] bg-dark-border mx-auto" data-id="element-182" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-183">
          {reasons.map((reason, index) => <motion.div key={index} variants={itemVariants} className="bg-dark-card border border-dark-border p-4 sm:p-6 rounded-sm flex items-start gap-3 sm:gap-4 hover:border-red-dark/50 transition-colors duration-300" data-id="element-184">
              <XCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-urgent shrink-0 mt-0.5 sm:mt-1" data-id="element-185" />
              <p className="text-sm sm:text-base text-gray-300 leading-relaxed" data-id="element-186">
                {reason}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}